import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import { AuthGuard, SchoolGuard } from '../core';

import { DashboardComponent } from './dashboard.component';

const routes: Route[] = [
    {
        path: '',
        component: DashboardComponent,
        canActivate: [AuthGuard, SchoolGuard],
        data: { exclude: [{ id: 3, redirect: '/playlists' }] } // Redirect Pop of the Day to the playlists
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class DashboardRouting { }